/* tslint:disable */

import { CMSResource } from "app/resources/cmsresource";




export class AppointmentStatusResource extends CMSResource {

	value: string;

	nameRo: string;

	nameFr: string;

	nameEn: string;

	nameDe: string;

}
